import { call, put, takeEvery } from "redux-saga/effects"
import {
  GET_PROJECT_PACKAGES,
  GET_ALL_PROJECT_PACKAGES,
  UPDATE_PROJECT_PACKAGE_INSTALLER,
  UPDATE_PROJECT_PACKAGE_SERIAL,
} from "./actionTypes"
import {
  getProjectPackagesSuccess,
  getProjectPackagesFail,
  getAllProjectPackagesSuccess,
  getAllProjectPackagesFail,
  updateProjectPackageInstallerSuccess,
  updateProjectPackageInstallerFail,
  updateProjectPackageSerialSuccess,
  updateProjectPackageSerialFail,
  getProjectPackages as getProjectPackagesAction,
  getAllProjectPackages as getAllProjectPackagesAction,
} from "./actions"
import {
  getProjectPackagesApi,
  getAllProjectPackagesApi,
  updateProjectPackageInstallerApi,
  updateProjectPackageSerialApi,
} from "helpers/backend_helper"

function* getProjectPackagesSaga({ payload: gasProjectId }) {
  try {
    const response = yield call(getProjectPackagesApi, gasProjectId)
    yield put(getProjectPackagesSuccess(response))
  } catch (error) {
    yield put(getProjectPackagesFail(error || "خطا در دریافت اطلاعات پکیج‌ها"))
  }
}

function* getAllProjectPackagesSaga({ payload: gasProjectId }) {
  try {
    const response = yield call(getAllProjectPackagesApi, gasProjectId)
    yield put(getAllProjectPackagesSuccess(response))
  } catch (error) {
    yield put(getAllProjectPackagesFail(error || "خطا در دریافت لیست پکیج‌ها"))
  }
}

function* updateProjectPackageInstallerSaga({ payload }) {
  try {
    debugger
    const response = yield call(updateProjectPackageInstallerApi, payload)
    
    yield put(updateProjectPackageInstallerSuccess(response || "نصاب با موفقیت ثبت شد"))
    // Reload project packages after update
    yield put(getProjectPackagesAction(payload.gasProjectId))
  } catch (error) {
    debugger
    yield put(updateProjectPackageInstallerFail(error || "خطا در ثبت نصاب"))
  }
}

function* updateProjectPackageSerialSaga({ payload }) {
  try {
    const response = yield call(updateProjectPackageSerialApi, payload)
    yield put(updateProjectPackageSerialSuccess({ ...payload, response }))
    // Reload all project packages after update (with gasProjectId if provided)
    yield put(getAllProjectPackagesAction(payload.gasProjectId || null))
  } catch (error) {
    yield put(updateProjectPackageSerialFail(error || "خطا در ثبت سریال"))
  }
}

function* projectPackagesSaga() {
  yield takeEvery(GET_PROJECT_PACKAGES, getProjectPackagesSaga)
  yield takeEvery(GET_ALL_PROJECT_PACKAGES, getAllProjectPackagesSaga)
  yield takeEvery(UPDATE_PROJECT_PACKAGE_INSTALLER, updateProjectPackageInstallerSaga)
  yield takeEvery(UPDATE_PROJECT_PACKAGE_SERIAL, updateProjectPackageSerialSaga)
}

export default projectPackagesSaga
